import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardpageComponent } from './components/dashboardpage/dashboardpage.component';
import { GenerateClassificationComponent } from './components/generate-classification/generate-classification.component';
import { GenerateDescriptionComponent } from './components/generate-description/generate-description.component';
import { ViewClassificationComponent } from './components/view-classification/view-classification.component';
import { AuthGuard } from './guard/auth/auth.guard';
import { LoggedInGuard } from './guard/loggedInGuard/logged-in-guard.guard';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [LoggedInGuard] },
  { path: 'login', component: LoginComponent, canActivate: [LoggedInGuard] },
  { path: 'dashboard', component: DashboardpageComponent, canActivate: [AuthGuard] },
  { path: 'view-classification', component: ViewClassificationComponent, canActivate: [AuthGuard] },
  { path: 'generate', component: GenerateClassificationComponent, canActivate: [AuthGuard] },
  { path: 'output', component: GenerateDescriptionComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }